define('datamocks/issue',
    [
        'amplify'
    ],
    function (amplify) {
        "use strict";

        var module = {};

        module.registerServices = function () {

            amplify.request.define('get_all_issues', function (settings) {
                settings.success([]); // TODO: provide mock implementation
            });

            amplify.request.define('get_issue_by_id', function (settings) {
                settings.success({}); // TODO: provide mock implementation
            });

            amplify.request.define('get_issue_parameter', function (settings) {
                settings.success({}); // TODO: provide mock implementation
            });

        };

        return module;
    });
